import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import React from 'react';
import { render } from 'react-dom';

// import registerServiceWorker from './registerServiceWorker';
// import { unregister as unregisterServiceWorker } from './registerServiceWorker';

// CSS
import 'normalize.css';
import './fonts/ss-air/ss-air.css';

import App from './App';

render(<App />, document.getElementById('root'));

// registerServiceWorker();
// unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js